"use client";

import { Icon as AfaIcon } from "@afa-shared/afa-components";
import React from "react";

const Icon = (props: React.ComponentProps<typeof AfaIcon>) => {
  return <AfaIcon {...props} />;
};

export default Icon;
